import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class EquipmentEventLocalizationService {
  private static readonly EVENT_KEY_PREFIX = 'monitoring.notification.events.';
  private static readonly CATEGORY_KEY_PREFIX = 'monitoring.notification.categories.';

  constructor(private readonly translateService: TranslateService) {}

  public getDescription(code?: string, severity?: string): string {
    return this.translate(EquipmentEventLocalizationService.EVENT_KEY_PREFIX, code, severity);
  }

  public getCategoryName(code?: string): string {
    return this.translate(EquipmentEventLocalizationService.CATEGORY_KEY_PREFIX, code);
  }

  private translate(prefix: string, code?: string, suffix?: string): string {
    if (!code) {
      return '-';
    }

    const suffixKey = suffix ? `.${suffix.toLowerCase()}` : '';
    const key = `${prefix}${code}${suffixKey}`;
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : code;
  }
}
